import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { validationTypes } from '../../helpers/text-field-validators';

function ValidationTextField({
  Component,
  value,
  validationtype,
  helperTextColor,
  showErrorMessage,
  ...other
}) {
  const [errorMessage, setErrorMessage] = useState('');
  const handleOnBlur = useCallback(() => {
    const { truthFunction, message } = validationTypes(value)[validationtype];
    if (!truthFunction() && value) {
      setErrorMessage(message);
    }
  }, [value]);

  useEffect(() => {
    const { truthFunction } = validationTypes(value)[validationtype];
    if (truthFunction() || !value) {
      setErrorMessage('');
    }
  }, [value, validationtype]);

  // Only pass helperText if Component is TextField
  // Other input components (FilledInput, OutlinedInput, Input) should use FormHelperText
  // when wrapped in FormControl instead of the helperText prop
  const isTextField = Component === TextField;
  const componentProps = {
    onBlur: handleOnBlur,
    error: Boolean(errorMessage),
    value,
    ...other,
  };

  if (isTextField) {
    componentProps.helperText = (
      <Typography variant="caption" color={helperTextColor}>
        {showErrorMessage && errorMessage}
      </Typography>
    );
  }

  return <Component {...componentProps} />;
}
export default ValidationTextField;

ValidationTextField.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  validationtype: PropTypes.oneOf(['email', 'phone', 'text', 'rut', 'rfc']),
  // eslint-disable-next-line react/forbid-prop-types
  Component: PropTypes.object,
  helperTextColor: PropTypes.string,
  showErrorMessage: PropTypes.bool,
};

ValidationTextField.defaultProps = {
  validationtype: 'email',
  value: undefined,
  Component: TextField,
  helperTextColor: 'error',
  showErrorMessage: true,
};
